function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.0524 20.8759C1.19937 21.9479 1.51548 22.9779 2.19786 23.9134C3.42497 25.5954 5.34146 26.6755 7.1378 27.6449C10.0656 29.2242 17.3536 31.6073 17.5052 35.817H17.7199V33.3092C17.5577 28.7938 14.9204 26.7012 11.0944 24.6937C9.08811 23.6404 6.98382 22.7294 5.0825 21.4871C4.23099 20.9307 3.40281 20.3137 2.7146 19.5578C2.35067 19.1589 2.02173 18.7366 1.76277 18.2607C1.71961 18.1814 1.68112 18.0928 1.64379 18.0006C1.51782 18.2911 1.30086 18.8556 1.16205 19.475C1.05707 19.9416 0.996411 20.4385 1.05123 20.8736L1.0524 20.8759Z",
  fill: "url(#paint0_linear_3019_6)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.58163 16.5927C3.24884 15.8275 4.05136 15.2034 4.89238 14.64C6.7762 13.3779 8.87232 12.4634 10.8763 11.4194C14.7746 9.38748 17.5542 7.31353 17.7199 2.69087V0.181824H17.5053C17.3548 4.38806 10.0586 6.78279 7.1343 8.35167C5.34263 9.31283 3.41798 10.407 2.19553 12.082C0.920597 13.8317 0.91943 15.9161 0.920597 17.9959C0.920597 18.9676 0.924096 19.9381 1.05241 20.8759C0.92293 19.8646 1.42451 18.5103 1.64497 18.0018C1.68346 17.9073 1.72312 17.8151 1.76744 17.7335C1.99374 17.3182 2.27135 16.9461 2.58163 16.5903V16.5927Z",
  fill: "url(#paint2_linear_3019_6)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.40602 26.0071C3.46586 25.3411 2.74499 24.6564 2.20259 23.9133C1.59953 23.0875 1.2391 22.1415 1.06646 20.9366C1.01047 20.5516 0.983643 20.1947 0.983643 19.8448C0.983643 19.0656 1.21227 18.4333 1.43623 17.9189C1.48055 17.8058 1.52371 17.7101 1.56804 17.6308C1.78266 17.2377 2.04978 16.8621 2.40905 16.4504C3.00161 15.7715 3.74931 15.1381 4.76179 14.4604C6.12771 13.5447 7.62077 12.8029 9.06484 12.0867C9.62824 11.8067 10.2056 11.5198 10.7667 11.2282C14.9111 9.06788 17.566 6.97642 17.7199 2.6862L17.7153 0.181824H17.7048L17.7106 2.6897C17.552 7.0884 15.0814 9.22068 10.867 11.4183C10.3036 11.7111 9.72505 11.9992 9.16516 12.2768C7.72342 12.993 6.23619 13.7314 4.88193 14.6389C3.88578 15.3061 3.15092 15.9266 2.57119 16.5915C2.22242 16.9928 1.96346 17.3544 1.75584 17.7346C1.71618 17.8058 1.67652 17.8944 1.63452 18.0018C1.41873 18.4998 1.15628 19.2685 1.15628 20.0081C1.15628 20.2938 1.13995 20.5411 1.20294 20.9797C1.37091 22.1485 1.75 23.161 2.3309 23.9577C2.8593 24.6809 3.48569 25.3551 4.40602 26.0071Z",
  fill: "url(#paint3_linear_3019_6)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.76397 18.2619C1.80363 18.3354 1.84912 18.4077 1.89345 18.48C1.84096 18.3925 1.7873 18.3039 1.74414 18.2245L1.76397 18.2619Z",
  fill: "url(#paint4_linear_3019_6)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7199 33.3103C17.5624 28.9291 15.1712 26.8341 11.0944 24.6948C10.4902 24.3776 9.86732 24.0685 9.26543 23.7698L9.23627 23.7558C7.84352 23.0653 6.40295 22.3514 5.08369 21.4883C4.03971 20.8059 3.31068 20.211 2.71578 19.5589C2.37168 19.1822 2.10806 18.8334 1.89343 18.4811C2.13256 18.8812 2.451 19.3431 2.80093 19.7269C3.40749 20.393 4.14469 20.9774 5.20383 21.6702C6.53476 22.5392 7.74204 23.2554 9.14412 23.9495L9.16978 23.9623C9.77167 24.2609 10.3934 24.5689 10.9953 24.885C15.0032 26.9869 17.3525 29.0411 17.5064 33.3138L17.5018 35.7108V35.8182H17.7211V35.7108H17.7164L17.7211 33.3103H17.7199Z",
  fill: "url(#paint5_linear_3019_6)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4855 12.7166C17.342 16.7233 10.5801 19.0877 7.76658 20.5481C3.86595 22.5719 1.08629 24.6634 0.920654 29.2802V31.7881H1.13528C1.27876 27.7825 8.0407 25.4169 10.8542 23.9565C14.7548 21.9327 17.5333 19.8401 17.6989 15.2244V12.7166H17.4843H17.4855Z",
  fill: "url(#paint6_linear_3019_6)"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1.13992 31.7881H0.925293V31.6808C1.14459 28.2549 5.93405 26.0305 9.10214 24.5584C9.72736 24.268 10.3013 24.002 10.755 23.7652C14.8994 21.6143 17.5496 19.5263 17.7036 15.2198L17.6989 12.7154H17.6943L17.6989 15.2233C17.5403 19.6395 15.0697 21.7682 10.8542 23.9554C10.3957 24.1933 9.81951 24.4616 9.20946 24.745C6.07053 26.2031 1.35105 28.3949 1.13992 31.6866V31.7869V31.7881Z",
  fill: "url(#paint7_linear_3019_6)"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0204 14.1758L35.681 14.8418C35.527 14.773 34.0596 14.0918 32.4079 14.0918C29.2725 14.0918 26.9851 16.5635 26.9851 19.3782C26.9851 22.1928 29.2002 24.661 32.2539 24.661C33.3446 24.661 34.7093 24.3729 35.9714 23.2636V20.281H32.5946V19.531H36.7705V23.5716C35.2552 25.053 33.719 25.4811 32.2539 25.4811C28.7744 25.4811 26.0997 22.7702 26.0997 19.3782C26.0997 15.9861 28.8257 13.2753 32.3239 13.2753C33.5499 13.2753 34.9648 13.6485 36.0216 14.1758H36.0204Z",
  fill: "#A70E13"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0097 16.4947L40.1625 18.1663C40.6408 17.0056 41.7314 16.4784 42.9935 16.4784V17.3812C41.5273 17.3812 40.215 18.1499 40.215 20.0081V25.3446H39.3635V16.4959H40.0109L40.0097 16.4947Z",
  fill: "#A70E13"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M45.8572 16.4772V21.6761C45.8572 23.4829 46.6084 24.6587 48.7547 24.6587C50.3084 24.6587 51.637 23.3488 51.637 21.7612V16.476H52.4897V25.3411H51.8423L51.7058 23.6182C51.0922 24.8792 49.9165 25.4764 48.6205 25.4764C46.164 25.4764 45.0045 24.1291 45.0045 21.7927V16.4749H45.8584L45.8572 16.4772Z",
  fill: "#A70E13"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M64.0655 20.9109C64.0655 23.3301 62.3426 25.4787 59.7834 25.4787C58.3534 25.4787 56.8346 24.7462 56.3062 23.3499V28.2409H55.4524V16.4772H56.1184L56.2561 18.5395C56.9373 16.9694 58.505 16.3395 59.7823 16.3395C62.2738 16.3395 64.0643 18.4018 64.0643 20.9109H64.0655ZM56.2223 20.9109C56.2223 23.0921 57.755 24.7112 59.7006 24.7112C61.6463 24.7112 63.2117 23.0245 63.2117 20.9109C63.2117 18.7973 61.6778 17.1071 59.7006 17.1071C57.7235 17.1071 56.2223 18.7798 56.2223 20.9109Z",
  fill: "#A70E13"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M70.4215 16.3407C72.9458 16.3407 74.9742 18.3365 74.9742 20.912C74.9742 23.4876 72.9458 25.4799 70.4215 25.4799C67.8973 25.4799 65.905 23.4514 65.905 20.912C65.905 18.3727 67.9323 16.3407 70.4215 16.3407ZM66.7554 20.912C66.7554 22.9918 68.3744 24.7123 70.4215 24.7123C72.4687 24.7123 74.1215 22.9918 74.1215 20.912C74.1215 18.8322 72.4862 17.1082 70.4215 17.1082C68.3569 17.1082 66.7554 18.7961 66.7554 20.912Z",
  fill: "#A70E13"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M85.6799 13.4094V15.6257H79.6097V18.5582H84.7771V20.7068H79.6097V25.3434H77.2219V13.4094H85.6799Z",
  fill: "#ED1C24"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M89.5129 12.8635V22.9394C89.5129 23.161 89.6342 23.2461 89.822 23.2461C90.0623 23.2461 90.2828 23.2298 90.6409 23.196V25.0518C90.572 25.1055 89.6505 25.3434 88.9343 25.3434C87.7597 25.3434 87.1788 24.5759 87.1788 23.5366V12.8635H89.5129Z",
  fill: "#ED1C24"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M96.0777 16.3069C98.8224 16.3069 100.151 18.4368 100.151 20.7907C100.151 21.388 100.067 21.8137 100.067 21.8137H94.1158C94.2196 23.0758 95.3102 23.5529 96.3682 23.5529C97.4261 23.5529 98.294 23.2811 98.8737 23.0245L99.6564 24.7462C98.7699 25.2548 97.5101 25.5125 96.3157 25.5125C93.6375 25.5125 91.6779 23.7057 91.6779 20.9949C91.6779 18.284 93.4497 16.3069 96.0766 16.3069H96.0777ZM97.9347 20.176C97.8857 19.2044 97.5101 18.3528 96.213 18.3528C95.1037 18.3528 94.3059 18.9839 94.0819 20.176H97.9347Z",
  fill: "#ED1C24"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M104.02 16.4772V21.6761C104.02 22.7177 104.55 23.2613 105.692 23.2613C106.628 23.2613 107.396 22.7854 107.396 21.7111V16.4772H109.781V25.3422H107.957L107.666 24.3356C107.087 25.1043 106.254 25.5125 105.145 25.5125C102.844 25.5125 101.67 24.1664 101.67 21.795V16.4772H104.02Z",
  fill: "#ED1C24"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M113.771 16.5635L114.077 17.9621C114.622 16.8365 115.544 16.4784 117.112 16.4784V18.8988H116.822C115.32 18.8988 114.246 19.4785 114.246 21.3892V25.3446H111.895V16.5647H113.769L113.771 16.5635Z",
  fill: "#ED1C24"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M119.941 16.4772L122.125 22.8705H122.176L124.425 16.4772H126.898L123.095 25.9045C122.431 27.541 121.783 28.2397 120.334 28.2397C119.718 28.2397 119.088 28.1546 118.423 27.9493L118.834 25.8193C119.139 25.8706 119.875 25.9885 120.264 25.9733C120.623 25.9733 120.791 25.6315 120.914 25.2909L117.468 16.476H119.941V16.4772Z",
  fill: "#ED1C24"
});
var _ref20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3019_6",
  x1: 1.0314,
  y1: 26.91,
  x2: 17.7199,
  y2: 26.91,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#540304"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#79090C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#980F13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#AF1218"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#C0151C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#CA171E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#CE181F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#CA171E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#C0151C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#AF1218"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#980F13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#79090C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#540304"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E0000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3019_6",
  x1: 6.59889,
  y1: 21.6096,
  x2: 10.2977,
  y2: 28.1908,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E0000",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#230000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E0000",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_3019_6",
  x1: 0.920597,
  y1: 10.5294,
  x2: 17.7199,
  y2: 10.5294,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9E0B0F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#B71015"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#CE151B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#DF1920"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#E91B23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#ED1C24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#ED1F25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#ED2929"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#EE3A31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#F0513B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#F15B40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#F0573E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#F04D3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#EF3C32"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#ED2528"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#ED1C24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E91B23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#DF1920"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#CE151B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#B71015"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9E0B0F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_3019_6",
  x1: 2.16643,
  y1: 20.4338,
  x2: 6.72143,
  y2: 16.6732,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED1B34"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9E0B0F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_3019_6",
  x1: 1.74414,
  y1: 18.3529,
  x2: 1.89345,
  y2: 18.3529,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9E0B0F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1B34"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_3019_6",
  x1: 1.89343,
  y1: 27.1491,
  x2: 17.7199,
  y2: 27.1491,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9E0B0F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1B34"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_3019_6",
  x1: 0.920654,
  y1: 22.2523,
  x2: 17.6989,
  y2: 22.2523,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9E0B0F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#B71015"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#CE151B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#DF1920"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#E91B23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#ED1C24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#ED1F25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#ED2929"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#EE3A31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#F0513B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#F15B40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#F0573E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#F04D3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#EF3C32"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#ED2528"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#ED1C24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E91B23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#DF1920"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#CE151B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#B71015"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9E0B0F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_3019_6",
  x1: 1.18191,
  y1: 27.0465,
  x2: 9.58039,
  y2: 22.1567,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED1B34"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9E0B0F"
})));
const SvgFleuryLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 36,
    viewBox: "0 0 127 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.0524 20.8759C1.19937 21.9479 1.51548 22.9779 2.19786 23.9134C3.42497 25.5954 5.34146 26.6755 7.1378 27.6449C10.0656 29.2242 17.3536 31.6073 17.5052 35.817H17.7199V33.3092C17.5577 28.7938 14.9204 26.7012 11.0944 24.6937C9.08811 23.6404 6.98382 22.7294 5.0825 21.4871C4.23099 20.9307 3.40281 20.3137 2.7146 19.5578C2.35067 19.1589 2.02173 18.7366 1.76277 18.2607C1.71961 18.1814 1.68112 18.0928 1.64379 18.0006C1.51782 18.2911 1.30086 18.8556 1.16205 19.475C1.05707 19.9416 0.996411 20.4385 1.05123 20.8736L1.0524 20.8759Z",
    fill: "url(#paint1_linear_3019_6)"
  }), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFleuryLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fleuryLogo.f9e04c54.svg";
export { ForwardRef as ReactComponent };